module.exports = __webpack_public_path__ + "static/media/iPhoneX.564f46a6.png";